module.exports = __webpack_public_path__ + "static/media/PSSTO.dc839eb7.svg";